import React, { PropTypes } from 'react';
import { TextField, Checkbox, FontIcon, CircularProgress } from 'material-ui';
import FlatButton from '../../../tc-ui/flat-button-with-loader';
import StepperActions from '../../generic-components/stepper-actions';
import { groupBy, isEmpty, complement } from 'ramda';
const isNotEmpty = complement(isEmpty);

const DownloadPDFAsDraft = ({
  onRequestClose,
  draftErrors,
  downloadContractPdf,
}) => {
  return (
    <div style={{ padding: '24px' }}>

      {
        draftErrors.errorExist ? (
          <div>
            <div style={{ margin: '0 36px 48px 36px' }}>
              We are checking if your draft has all the required information so we can generate a complete draft pdf.
            </div>
          </div>) : (
          <div style={{ margin: '0 36px 24px 36px', fontSize: '16px', lineHeight: '24px' }}>
            Congratulations! Your draft has passed all requirement checks.
            <div> Please click 'Download PDF' button to preview your contract.</div>
          </div>
        )
      }
      <StepperActions rightButtons={
        <div>
          <FlatButton
            label="Cancel"
            hoverColor="none"
            labelStyle={{ fontWeight: '600', marginRight: '15px' }}
            primary
            onTouchTap={onRequestClose}
          />

          <FlatButton
            label="Download PDF"
            hoverColor="none"
            labelStyle={{ fontWeight: '600' }}
            onTouchTap={e => downloadContractPdf(e.currentTarget)}
            secondary
          />
        </div>
        }
      />
    </div>
  );
};

export default DownloadPDFAsDraft;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/publish-draft-content/downloadPDFAsDraft.jsx